import type { ReactNode } from "react";

import { HaNContext, HaNSearchContext, useFacilityCategoryOnMap } from "@lib/logic";
import { useRequiredContext } from "@lib/utils";

import { useHaNLayoutMode } from "../../state/layout/useHaNLayoutMode";
import { HaNLinkedNode } from "./HaNLinkedNode";

type HaNPageGridProps = {
  children?: ReactNode;
};

// Regions place themselves in this grid. On phones `data-map-list-view` switches them between map and list in CSS.
export const HaNPageGrid = ({ children }: HaNPageGridProps) => {
  const { mapListView } = useRequiredContext(HaNContext);
  const { isSearching } = useRequiredContext(HaNSearchContext);
  const layoutMode = useHaNLayoutMode();
  const categoryOnMap = useFacilityCategoryOnMap({ isPhoneLayout: layoutMode === "mobile" });

  const getShownView = () => {
    if (categoryOnMap) return "map";
    if (isSearching) return "list";

    return mapListView.view;
  };

  return (
    <div
      data-map-list-view={getShownView()}
      className="group/han isolate grid size-full overflow-hidden bg-white grid-cols-[375px_1fr] grid-rows-[auto_auto_auto_1fr] max-sm:grid-cols-1 max-sm:grid-rows-[60px_auto_auto_auto_1fr]">
      <HaNLinkedNode />
      {children}
    </div>
  );
};
